import React from 'react';
import PropTypes from 'prop-types';

import { getRange, isValidIPItemValue } from './helper';

import style from './index.less';

class IpInput extends React.Component {
  state = {
    value: []
  };

  componentDidMount() {
    let { value = '...' } = this.props;
    if (value && !Array.isArray(value)) {
      value = value.split('.');
      this.setState({ value });
    } else {
      this.setState({ value: ['', '', '', ''] });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value = '...' } = nextProps;
    let setValue;
    if (value && !Array.isArray(value)) {
      setValue = value.split('.');
      this.setState({ value: setValue });
    } else {
      this.setState({ value: ['', '', '', ''] });
    }
  }

  /**
   * Change Event
   */
  handleChange(e, i) {
    let val = parseInt(e.target.value);
    if (isNaN(e.target.value)) {
      return e.preventDefault();
    }

    if (e.target.value !== '' && !isValidIPItemValue(val)) {
      val = 255;
    }

    const { value } = this.state;
    value[i] = val;
    this.setState({ value }, () => this.onPropsChange());

    if (!isNaN(val) && String(val).length === 3 && i < 3 && this[`_input-${i + 1}`]) {
      this[`_input-${i + 1}`].focus();
    }
    return false;
  }

  /**
   * Keydown Event
   */
  handleKeyDown(e, i) {
    /* 37 = ←, 39 = →, 8 = backspace */
    let domId = i;
    if ((e.keyCode === 37 || e.keyCode === 8) && getRange(e.target).end === 0 && i > 0) {
      domId = i - 1;
    }
    if (e.keyCode === 39 && getRange(e.target).end === e.target.value.length && i < 3) {
      domId = i + 1;
    }
    this[`_input-${domId}`].focus();
  }

  /**
   * Paste Event
   */
  handlePaste(e, i) {
    if (!e.clipboardData || !e.clipboardData.getData) {
      return;
    }

    const pasteData = e.clipboardData.getData('text/plain');
    if (!pasteData) {
      return;
    }

    const value = pasteData.split('.').map(v => parseInt(v));
    if (value.length !== 4 - i) {
      return;
    }

    if (!value.every(isValidIPItemValue)) {
      return;
    }

    const { value: oldValue } = this.state;
    value.forEach((val, j) => {
      oldValue[i + j] = val;
    });

    this.setState({ value: oldValue }, () => this.onPropsChange());
    e.preventDefault();
  }

  /**
   * call change props
   */
  onPropsChange() {
    const { value } = this.state;
    const ip = value.map(val => (isNaN(val) ? '' : val)).join('.');
    return this.props.onChange(ip);
  }

  render() {
    const { value } = this.state;
    const ip = value.map(val => (isNaN(val) ? '' : val)).join('.');

    const className = [
      style['react-ip-input'],
      this.props.className,
      this.props.isError(ip) ? style['has-error'] : ''
    ].join(' ');

    return (
      <div className={className}>
        {value.map((val, i) => (
          <div className={style['react-ip-input__item']} key={`_input-${i}`}>
            <input
              ref={el => (this[`_input-${i}`] = el)}
              type="text"
              value={isNaN(val) ? '' : val}
              onChange={e => this.handleChange(e, i)}
              onKeyDown={e => this.handleKeyDown(e, i)}
              onPaste={e => this.handlePaste(e, i)}
            />
            {i !== 3 ? <i>.</i> : false}
          </div>
        ))}
      </div>
    );
  }
}

IpInput.defaultProps = {
  className: '',
  isError: () => false,
  onChange: () => null
};

IpInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string || PropTypes.array,
  isError: PropTypes.func,
  onChange: PropTypes.func
};

const Range = ({ value = ['...', '...'], onChange = () => null, type }) => {
  const [begin, end] = value;
  const multipleChange = (type, value) => {
    if (type === 1) {
      onChange([value, end]);
    }
    if (type === 2) {
      onChange([begin, value]);
    }
  };

  const singleChange = value => {
    onChange([value, value]);
  };

  const renderMultiple = () => {
    return (
      <ul className={style.multiple}>
        <li>
          <IpInput value={begin} onChange={val => multipleChange(1, val)} />
        </li>
        <li>-</li>
        <li>
          <IpInput value={end} onChange={val => multipleChange(2, val)} />
        </li>
      </ul>
    );
  };

  return type !== 'multiple' ? (
    <div>
      <IpInput value={begin} onChange={singleChange} />
    </div>
  ) : (
    renderMultiple()
  );
};

IpInput.Range = Range;

export default IpInput;
